import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { WorkflowProjectPicker } from '@/features/workflows/workflow-project-picker';

/** « Nouveau workflow » hors projet : l'éditeur de graphe s'ouvre dans un projet, choisi si nécessaire. */
export const Route = createFileRoute('/$tenant/workflows/editor')({ component: WorkflowEditorEntryRoute });

function WorkflowEditorEntryRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="workflows"
      crumbs={[{ label: t('nav.items.workflows') }, { label: t('workflowEditor.newTitle') }]}
    >
      <WorkflowProjectPicker tenantId={tenant} />
    </ConsoleShell>
  );
}
